/**
 * MSAL Configuration for Azure AD Authentication
 */

// Get configuration from environment variables
const getConfig = () => {
  const clientId = import.meta.env.VITE_AZURE_CLIENT_ID || '';
  const tenantId = import.meta.env.VITE_AZURE_TENANT_ID || '';
  const redirectUri = import.meta.env.VITE_REDIRECT_URI || window.location.origin;

  return { clientId, tenantId, redirectUri };
};

const { clientId, tenantId, redirectUri } = getConfig();

/**
 * MSAL Configuration object
 */
export const msalConfig = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
    postLogoutRedirectUri: redirectUri,
    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
    claimsBasedCachingEnabled: true
  },
  system: {
    iframeHashTimeout: 6000,
    loadFrameTimeout: 6000,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case 0: // Error
            console.error('[MSAL]', message);
            break;
          case 1: // Warning
            console.warn('[MSAL]', message);
            break;
          case 2: // Info
            if (import.meta.env.DEV) {
              console.info('[MSAL]', message);
            }
            break;
          case 3: // Verbose
            if (import.meta.env.DEV) {
              console.debug('[MSAL]', message);
            }
            break;
          default:
            break;
        }
      },
      logLevel: import.meta.env.DEV ? 2 : 0,
      piiLoggingEnabled: false
    }
  }
};

/**
 * Scopes for authentication
 * User.Read is needed for profile picture access from Graph API
 */
export const loginRequest = {
  scopes: ['openid', 'profile', 'email', 'User.Read']
};

/**
 * Check if MSAL is properly configured
 */
export const isMsalConfigured = () => {
  return clientId && clientId !== '' && tenantId && tenantId !== '';
};

export default msalConfig;
